export const AS_FIRST_ELEMENT_OPTION_ID = 'as-first-element';
